//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        // The optional tab prop allows specifying the selected tab from the outside
        tab: String,
        large: Boolean,
        vertical: Boolean,
        flipIndicator: Boolean,
        noFit: Boolean,
    },

    data() {
        return {
            tab_: null,
        };
    },

    watch: {
        tab(val) {
            this.tab_ = val;
        },
        tab_: {
            handler(val) {
                this.$emit('tab', val);
            },
            immediate: true,
        },
    },

    methods: {
        getTabComponents() {
            return this.$slots.default.filter(v => v.componentOptions?.tag === 'UniTab');
        },
        getTabProps(tabComponent, ...keys) {
            return _.pick(tabComponent.componentOptions.propsData, keys);
        },
        isShown(tabComponent) {
            return !tabComponent.componentOptions.propsData.hide;
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.tab_ = this.tab || this.getTabComponents()[0]?.componentOptions.propsData.name;
        });
    },
};
